export {default} from './AllChat';



// WEBPACK FOOTER //
// ./src/pages/AllChat/index.ts